angular.module('eStories.library.top.bar', [])
    .component('libraryTopBar', {
        transclude: true,
        bindings: {
            tabList: '<',
            selectedTabIndex: '<',
            sortFieldList: '<',
            selectedSortFieldIndex: '<',
            showGridView: '<'
        },
        controller: 'LibraryTopBarCtrl',
        controllerAs: 'libraryTopBarCtrl',
        templateUrl: '/components/library-top-bar/library-top-bar.tmpl.html'
    }).controller('LibraryTopBarCtrl',
    ['$scope', 'LL', 'ModalsModel', function ($scope, LL, ModalsModel) {
        if (this.selectedTabIndex == null) this.selectedTabIndex = 0;
        if (this.selectedSortFieldIndex == null) this.selectedSortFieldIndex = 0;
        if (this.showGridView == null) this.showGridView = false;

        this.$onChanges = async (changes) => {
            if (changes.selectedTabIndex) this.selectedTabIndex = changes.selectedTabIndex.currentValue;
            if (changes.tabList) this.tabList = changes.tabList.currentValue;
            if (changes.sortFieldList) this.sortFieldList = changes.sortFieldList.currentValue;
            if (changes.selectedSortFieldIndex) this.selectedSortFieldIndex = changes.selectedSortFieldIndex.currentValue;
            if (changes.showGridView) this.showGridView = changes.selectedSortFieldIndex.showGridView;
        };

        this.getGridListButtonClass = () => {
            return this.showGridView ? 'list__button' : 'grid__button';
        };
        this.toggleGridListButton = () => {
            this.showGridView = !this.showGridView;
            $scope.$emit("gridListButtonClicked", this.showGridView);
        };

        this.showUploadModal = function () {
            LL.tagEvent("Upload Select");
            ModalsModel.open('/uploader/uploadModal.tmpl.html', 'UploadCtrl', 'uploadCtrl')
        };

        this.getCurrentSortField = () => {
            if (this.selectedSortFieldIndex == null) {
                return null;
            }

            return this.sortFieldList[this.selectedSortFieldIndex];
        };

        this.tabClicked = (tab, index) => {
            if (index === this.selectedTabIndex) {
                return;
            }
            $scope.$emit("tabSelected", tab, index);
        };
        this.selectSortField = (sortField, index) => {
            if (index === this.selectedSortFieldIndex) {
                return;
            }
            $scope.$emit("sortFieldSelected", sortField, index);
        };
    }]
);
